import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useParams, useLocation } from "react-router-dom";
import { AccountContext } from '../../../../../../components/AccountContext';
import ValidImportDefinitionList from './ValidImportDefinitionList';
import {
  parse, filterPaginationWithSize, emptyConnection,
} from '../../../../../../utils/UrlUtil';

const DEFINITION_FILE_IMPORT = gql`
query ($accountId: ID!, $respondentImportId: ID!,
  $filter: RespondentDefinitionFilter,
  $first: Int, $after: String, $last: Int, $before: String) {
  account(id: $accountId) {
    id
    respondentImport(respondentImportId: $respondentImportId) {
      id
      respondentDefinitions(filter: $filter,
        first: $first, after: $after,
        last: $last, before: $before) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            firstName
            lastName
            email
            gender
            locale
            ownEmployee
          }
        }
      }
    }
  }
}
`;

const ValidImportDefinitionContainer = () => {
  const currentAccount = useContext(AccountContext);
  const { importFileId } = useParams();
  const location = useLocation();
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);
  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
    respondentImportId: importFileId,
  };

  return (
    <Query
      query={DEFINITION_FILE_IMPORT}
      variables={variables}
      notifyOnNetworkStatusChange
      fetchPolicy="network-only"
    >
      {({ data, loading, error }) => {
        if (error) return `Error! ${error.message}`;

        const connection = (data && data.account
          && data.account.respondentImport)
          ? data.account.respondentImport.respondentDefinitions
          : emptyConnection();

        return (
          <ValidImportDefinitionList
            connection={connection}
            loading={loading}
          />
        );
      }}
    </Query>
  );
}

export default ValidImportDefinitionContainer;
